import React from 'react';
import "../../css/main.css"

export function YearsElement(yearsData, handleYearClicked) {

    if(!yearsData)
    {
        yearsData = [];
    }
    return (
        <>
            
                    <div className='formbox'>
                        <div className='formtitle'>Year</div>
                        <div className='formrowcentered'>
                        {yearsData.map(function (year) {
                            return (                               
                                    <div style={{"paddingLeft":"0.5em","paddingRight":"0.5em" }} key={year}>
                                         <button type='button' key={year} name='year' className='prcbtn' onClick={event => handleYearClicked(year)}>{year}</button>
                                        </div>
                            );
                        })}
                        </div>
                    </div>
       
        </>

    );
}